import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="app-footer">
      <a href="/how-to-play">How to play</a>
      <span className="app-footer-sep">·</span>
      <a href="/tips">Tips</a>
      <span className="app-footer-sep">·</span>
      <a href="/faq">FAQ</a>
      <span className="app-footer-sep">·</span>
      <a href="/privacy">Privacy</a>
      <span className="app-footer-sep">·</span>
      <a href="/about">About</a>
      <span className="app-footer-sep">·</span>
      <a href="mailto:dontwordle@gmail.com">Contact</a>
    </footer>
  );
}

export default Footer;
